import { Checkbox, IconButton, Tooltip } from "@mui/material";

import "./freeFrom.scss";

const isDisabled = (parameterData) => {
  if (parameterData?.validatorRowRejection?.isRejected) {
    return true;
  } else {
    let isRejectedWithinCell;

    Object.keys(parameterData).map((key) => {
      if (parameterData[key]?.validatorCellRejection?.isRejected) {
        isRejectedWithinCell = true;
      }
    });

    if (isRejectedWithinCell) {
      return true;
    } else return false;
  }
};
const ValidationButton = ({
  onClickValidate,

  parameterData,
  parameterIndex,
}) => {
  return (
    <>
      <div className="sub-row validator">
        {parameterData?.rowValidation?.isValidated ? (
          <div className="validator-edit">
            <Tooltip
              title={`Validated On  :${parameterData?.rowValidation?.date}`}
              placement="top"
            >
              <IconButton>
                <input
                  type="checkbox"
                  checked={true}
                  onChange={(e) =>
                    onClickValidate("invalidate", parameterIndex)
                  }
                />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          <div className="checkbox-wrap ">
            <Checkbox
              onChange={(e) => onClickValidate("validate", parameterIndex)}
              disabled={isDisabled(parameterData)}
              size="small"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ValidationButton;
